import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoadingSpinnerService {
  public isLoading = false;
  public loadingSpinnerUpdates: Subject<boolean> = new Subject<boolean>;
  constructor() { }

  public getLoadingSpinnerUpdates(): Observable<boolean> {
    return this.loadingSpinnerUpdates.asObservable();
  }

  public disable(): void {
    this.isLoading = false;
    this.loadingSpinnerUpdates.next(false);
  }

  public enable(): void {
    this.isLoading = true;
    this.loadingSpinnerUpdates.next(true);
  }
}
